import { render, staticRenderFns } from "./ProvinceRisk copy.vue?vue&type=template&id=00e37fa8&scoped=true"
import script from "./ProvinceRisk copy.vue?vue&type=script&lang=js"
export * from "./ProvinceRisk copy.vue?vue&type=script&lang=js"
import style0 from "./ProvinceRisk copy.vue?vue&type=style&index=0&id=00e37fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e37fa8",
  null
  
)

export default component.exports